import { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';
import { logFeatureUsage } from '../lib/featureUsage';

// A visit is distinct from successful processing. Recheck on focus/visibility
// and after midnight even when an authenticated editor stays open for days.
export function useSignedInVisit() {
  const userId = useAuthStore((state) => state.user?.id);
  useEffect(() => {
    if (!userId) return;
    const ping = () => {
      if (document.visibilityState === 'visible') void logFeatureUsage('app_visit');
    };
    ping();
    window.addEventListener('focus', ping);
    document.addEventListener('visibilitychange', ping);
    const timer = window.setInterval(ping, 60_000);
    return () => {
      window.removeEventListener('focus', ping);
      document.removeEventListener('visibilitychange', ping);
      window.clearInterval(timer);
    };
  }, [userId]);
}
